import React from 'react';

import ReactPaginate from 'react-paginate';
import { PaginationContainer } from './styles';
import { NextArrow, PrevArrow } from '../../../assets';

const PaginationComponent = ({
    pageCount,
    handlePageChange,
    forcePage
}: {
    pageCount: number;
    handlePageChange: ({ selected }: { selected: number }) => void;
    forcePage?: number;
}) => {
    return (
        <PaginationContainer>
            <ReactPaginate
                breakLabel='...'
                nextLabel={<img src={NextArrow} alt='next' />}
                onPageChange={handlePageChange}
                pageRangeDisplayed={3}
                pageCount={pageCount}
                previousLabel={<img src={PrevArrow} alt='previous' />}
                renderOnZeroPageCount={null}
                pageClassName={'indexClassName'}
                containerClassName={'containerClassName'}
                pageLinkClassName={'pageLinkClassName'}
                activeClassName={'activeClassName'}
                activeLinkClassName={'activeLinkClassName'}
                forcePage={forcePage}
            />
        </PaginationContainer>
    );
};

export default PaginationComponent;
